import { Box, Typography } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";

const BotProgress = ({ botStatus, prepaid = false }) => {
  if (!botStatus) return null;

  let title = "";
  if (botStatus.bot_number === 1) title = "Processing Your Invoices Now...";
  else if (botStatus.bot_number === 2)
    title = prepaid
      ? "Performing prepaid charges..."
      : "Performing Vendor Costings...";
  else if (botStatus.bot_number === 4) title = "Finalizing Records...";

  // Choose bar color based on status
  let barColor = "#00C853"; // default green
  if (botStatus.status === "failed") barColor = "#00C853"; // red
  else if (botStatus.status === "in progress") barColor = "#00C853"; // yellow
  else if (botStatus.status === "partial") barColor = "#00C853"; // orange
  else if (botStatus.status === "pending") barColor = "#00C853"; // grey

  return (
    <Box sx={{ width: "60%", mt: 4, textAlign: "center" }}>
      <Typography sx={{ mb: 1, fontSize: "36px", fontWeight: 700 }}>
        {botStatus?.bot_number === 1
          ? prepaid
            ? "Getting and reading PDF invoices..."
            : "Preparing Vendor Costing Data.."
          : botStatus?.bot_number === 2
          ? prepaid
            ? "Performing prepaid charges.."
            : "Processing Your Invoices Now..."
          : botStatus?.bot_number === 4
          ? "Performing Vendor Costings..."
          : "Performing Storage & Late Fee"}
      </Typography>

      {/* Counts */}
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
        <Typography sx={{ fontSize: "14px" }}>{botStatus?.message} </Typography>
        <Typography sx={{ fontSize: "14px" }}>{botStatus.percent}%</Typography>
      </Box>

      {/* Progress bar */}
      <LinearProgress
        variant="determinate"
        value={botStatus.percent}
        sx={{
          height: 12,
          borderRadius: 6,
          "& .MuiLinearProgress-bar": {
            backgroundColor: barColor,
          },
          backgroundColor: "rgba(255,255,255,0.15)",
        }}
      />
    </Box>
  );
};

export default BotProgress;
